import { EventHelpers } from 'helpers/EventHelpers';

import { useActiveEvents } from 'hooks/use-active-events';
import { useEvents } from 'hooks/use-events';
import { useLocalEvent } from 'hooks/use-local-event';

// The event RE+ Showtime is about: the visitor's chosen event, else a running one, else the next show
const useShowtimeEvent = () => {
    const { localEvent } = useLocalEvent();
    const { events: activeEvents } = useActiveEvents();
    const { events } = useEvents();

    const sortedEvents = EventHelpers.sortByStart(events);
    const runningEvent = sortedEvents.find(EventHelpers.isHappeningNow);
    const upcomingEvent = sortedEvents.find(EventHelpers.isUpcoming);

    return localEvent ?? activeEvents[0] ?? runningEvent ?? upcomingEvent;
};

export { useShowtimeEvent };
